export default __webpack_public_path__ + "static/media/done.34bf4167.svg";